import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogContainer: {
    '& .MuiPaper-root': {
      width: '300px',
      height: '150px',
      gap: 1.5,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  },
  innerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  svg: {
    height: '16px',
    width: '16px'
  }
});
